import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaSave, FaArrowLeft } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import NestedMenu from "../components/Menu";

import { notifyUser } from "../utils/notifyUser";

const AppPerson = () => {
    const navigate = useNavigate();
    const { groupId } = useParams();
    const [selectedMenuIds, setSelectedMenuIds] = useState([]);
    const [masterMenuList, setMasterMenuList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [groupData, setgroupData] = useState(null);

    useEffect(() => {
        const fetchAssignedMenu = async () => {
            if(!groupId) return;

            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/security-groups/${groupId}`,
                    { withCredentials: true },
                );
                const { menu_list } = res.data;
                setgroupData(res.data);
                if(menu_list) {
                    const ids = JSON.parse(menu_list);
                    setSelectedMenuIds(ids.length > 0 ? ids : []);
                }

                const menuRes = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/menu/section-menu`,
                    { withCredentials: true },
                );
                setMasterMenuList(menuRes.data);
            } catch(error) {
                console.error("Error fetching menus:", error);
                notifyUser(null, "error", "Failed to load menus.", "toast", null, null, null, null, null, false, false, "top-center");
            }
        };

        fetchAssignedMenu();
    }, [groupId]);

    //  Save updated menu selections
    const handleSave = async () => {
        if(!groupId) return;
        setLoading(true);
        try {
            await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/security-groups/${groupId}/menu`,
                {
                    menuItemIds: selectedMenuIds,
                },
                { withCredentials: true },
            );
            notifyUser(null, "success", "Menu updated successfully!", "toast", null, null, null, null, null, false, false, "top-center");
        } catch(error) {
            console.error("Error updating menu:", error);
            notifyUser(null, "error", "Failed to update menu.", "toast", null, null, null, null, null, false, false, "top-center");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mx-auto p-6">
            <nav className="text-sm mb-4">
                <ul className="flex space-x-2 text-gray-600">
                    <li
                        className="cursor-pointer hover:text-blue-600"
                        onClick={() => navigate("/dashboard")}
                    >
                        Home
                    </li>
                    <li>/</li>
                    <li
                        className="cursor-pointer hover:text-blue-600"
                        onClick={() => navigate("/Security-Groups")}
                    >
                        Security Groups
                    </li>
                    <li>/</li>
                    <li className="font-semibold text-gray-800">
                        {groupData?.group_name}
                    </li>
                </ul>
            </nav>
            <div className="flex justify-center items-center min-h-screen   p-4">
                <div className="w-full max-w-3xl bg-white shadow-xl rounded-lg p-6 border border-gray-200">
                    {/* Header */}
                    <div className="flex justify-between items-center mb-6">
                        <h1 className="text-3xl font-bold text-gray-800">
                            Manage Group Menus
                        </h1>
                        <button
                            className="flex items-center bg-gray-600 text-white px-4 py-2 rounded-md hover:bg-gray-800 transition"
                            onClick={() => navigate("/security-Groups")}
                        >
                            <FaArrowLeft className="mr-2" /> Back
                        </button>
                    </div>

                    <p className="text-gray-600 mb-4">
                        Assign or update the pages accessible to this group.
                    </p>

                    {/* Nested Menu Component */}
                    <div className="bg-gray-50 p-4 rounded-md shadow-inner border border-gray-200">
                        <NestedMenu
                            menus={masterMenuList}
                            selectedMenuIds={selectedMenuIds}
                            onSelectionChange={setSelectedMenuIds}
                        />
                    </div>

                    {/* Save Button */}
                    <div className="flex justify-end mt-6">
                        <button
                            className={`flex items-center justify-center gap-2 px-6 py-2 text-white font-semibold rounded-md transition-transform ${
                                loading
                                    ? "bg-gray-400 cursor-not-allowed"
                                    : "bg-blue-500 hover:bg-blue-700 active:scale-95 shadow-md"
                            }`}
                            onClick={handleSave}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <div className="animate-spin border-2 border-white border-t-transparent w-4 h-4 rounded-full"></div>
                                    Saving...
                                </>
                            ) : (
                                <>
                                    <FaSave /> Save Changes
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AppPerson;
